import { render, staticRenderFns } from "./authModal.vue?vue&type=template&id=66295d6d"
import script from "./authModal.vue?vue&type=script&lang=js"
export * from "./authModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports